module.exports = __webpack_public_path__ + "img/40_69_008_730.9eb43654.jpg";